
import Vue from 'vue';
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import AlertModule from 'vux/src/plugins/alert/module'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {fetch,promptMessage } from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import {formatDate} from '../../../static/js/date';
Vue.use(ConfirmPlugin)

export default {

data () {
return {
headerName:'',
lookIf:true,
confirmTitle:'',
paramsData:{},
doctors:'',
dateTxt:'',
timeTxt:'',
listIF:true,
qt:false,
mindateTXT:'',
showDialog:false,
timeoValue: [],
doctorValue:[],
commonList: [],
doctorList:[],
}
},
directives: {
TransferDom
},
components: {
XHeader,PopupPicker,XButton,Cell,Group,Datetime,XDialog, Checklist,Flexbox, FlexboxItem,Confirm,ConfirmPlugin, AlertModule
},
methods:{
editClick(txt){
var _this = this;
this.$vux.confirm.show({
title: '提示',
content: '确认'+txt+"当前预约？",
onConfirm () {
if(txt == '修改'){    //点击修改按钮后
_this.lookIf = false;
_this.headerName = '确认预约';
_this.getList(txt);

}else {   //点击取消预约按钮后
var Canclesureparam = new URLSearchParams();
Canclesureparam.append('orderId',_this.paramsData.orderId);
Canclesureparam.append('bsuperOrderID',_this.paramsData.bsuperOrderID);
Canclesureparam.append('personInfoId',_this.paramsData.personInfoId);
Canclesureparam.append('orderClass',_this.paramsData.orderClass);
Canclesureparam.append('orderDate',_this.paramsData.orderDate);
Canclesureparam.append('shiftTime',_this.paramsData.shiftTime);
fetch('post',urlConfig.reservationDoctorCancel,Canclesureparam).then(response => {
promptMessage('提示','成功取消当前预约！');
_this.sucessMethod();

}).catch(error => {
})
}
}
})

},//修改预约
sucessMethod(){
this.$router.push('/reservationIndex?openid=' +this.paramsData.openid);

},  //提交成功执行
sureClick(){
if(this.dateTxt !='' && this.timeTxt !='' && this.doctors !='')
{
if(!this.qt){
this.qt = true;
}
if(this.paramsData.orderStatus == '未预约'){
var sureparam = new URLSearchParams();
sureparam.append('personInfoId',this.paramsData.personInfoId);
sureparam.append('orderClass',this.paramsData.orderClass);
sureparam.append('orderName',this.paramsData.orderName);
sureparam.append('orderDate',this.dateTxt);
sureparam.append('timeStepId',this.timeStepId);
sureparam.append('reqDeptId',null);
sureparam.append('area',this.AREA);
sureparam.append('bsuperPayStatus',this.paramsData.bsuperPayStatus);
sureparam.append('bsuperOrderID',this.paramsData.bsuperOrderID);
sureparam.append('doctorId',this.doctorId);
sureparam.append('doctorName',this.doctors);

fetch('post',urlConfig.reservationDoctorSure,sureparam).then(response => {

promptMessage('提示','您已成功预约“重复周期门诊”，请准时来院并于前台分诊，刷新当前预约界面可获得“B超、血激素四项”项目，建议在医师指导下使用！');
this.sucessMethod();

}).catch(error => {
this.qt = false;
})
}

}else if(this.dateTxt ==''){
promptMessage('提示','请选择预约日期！');
}else if(this.doctors ==''){
promptMessage('提示','请选择预约医生！');
}else if(this.timeTxt ==''){
promptMessage('提示','请选择预约时间段！');
}

},//确认提交
timeChange(value,label){

this.showDialog = false;
if(!this.lookIf && label.toString() !=''){
if(this.listIF){   //医生
this.doctors = label.toString();
this.doctorId = value.toString();
this.qt = true;
for(let id = 0;id<this.doctorList.length;id++){
if(this.doctorList[id].value == label){
this.doctorsorderId = this.doctorList[id].id
this.AREA = this.doctorList[id].AREA
}

}
if(label == '其他'){
this.qt = true;
promptMessage('提示','若想选其他医生看诊，请拨打锦欣生殖客服热线：027-82889968 进行人工预约！');
}else {
this.qt = false;
}
}else {
this.timeTxt = label.toString();
this.timeStepId = value.toString();
}

}

},//选择时间
timeClick(txt){
if(!this.lookIf){
if(this.dateTxt != ''){
if(txt == '医生'){
this.listIF = true;
this.showDialog = true;
}else {
if(this.doctors != ''){
this.showDialog = true;
this.listIF = false;
this.getList();
}else {
promptMessage('提示','请先选择预约医生！');
}


}
}else {
promptMessage('提示','请先选择预约日期！');
}

}



}, //打开时间段预约框
refactoringPage(){
this.paramsData = this.$route.params;
console.log(this.paramsData,8)
var orderStatus = this.paramsData.orderStatus
if(orderStatus == '已预约'){
this.dateTxt = this.paramsData.orderDate;
this.timeTxt = this.paramsData.shiftTime;
this.doctors = this.paramsData.orderDoctorName;
this.headerName = '详情';
this.lookIf = true;
}else {
this.headerName = '确认预约';
this.lookIf = false;
}


},
getList(){
var timeparams = new URLSearchParams();
console.log(this.doctorsorderId,2)
timeparams.append('orderItemId',this.doctorsorderId)
timeparams.append('orderDate',this.dateTxt)
fetch('post',urlConfig.reservationDoctorDate,timeparams).then(response => {
this.commonList = [];
var orderTimedata = response;
for(let i =0;i<orderTimedata.length;i++){
this.commonList.push({});
this.commonList[i]['key']= orderTimedata[i].scheTimeId;
this.commonList[i]['value']= orderTimedata[i].canOrderNum;
}
console.log(this.commonList)

}).catch(error => {

})
},
dateChange(){
if(!this.lookIf) {
this.timeTxt = '';
this.timeoValue = [];
this.doctors = '';
this.doctorValue = [];
/* this.getList('选择');*/
var timedate = new URLSearchParams();
timedate.append('dutyDate', this.dateTxt)
fetch('post', urlConfig.reservationDoctorList, timedate).then(response => {
console.log(response, 8)
this.doctorList = [];
var orderdoctorList = response;
for (let i = 0; i < orderdoctorList.length; i++) {
this.doctorList.push({});
this.doctorList[i]['id'] = orderdoctorList[i].ORDERID;
this.doctorList[i]['value'] = orderdoctorList[i].DOCTORNAME;
this.doctorList[i]['key'] = orderdoctorList[i].DOCTERID;
this.doctorList[i]['AREA'] = orderdoctorList[i].AREA;
}
}).catch(error => {
console.log('error' + error)
});  //获取值班医生

}

}, //获取时间段
},
mounted(){
var threeday = new Date().getTime() + 3 * 24 * 3600 * 1000;
this.refactoringPage();
this.mindateTXT = formatDate(new Date(threeday), 'yyyy-MM-dd');

}
}



// WEBPACK FOOTER //
// ./src/project/MyReservationProject/reservationDoctor.vue